var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationsHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.5C20 15.6159 16.3902 19 12 19C7.56098 19 4 15.6616 4 11.5C4 7.33841 7.56098 4 12 4C16.3902 4 20 7.33841 20 11.5Z",
    fill: "url(#paint0_linear_6043_57)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.5C20 15.6159 16.3902 19 12 19C7.56098 19 4 15.6616 4 11.5C4 7.33841 7.56098 4 12 4C16.3902 4 20 7.33841 20 11.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.16114 0 0 5.12651 0 11.5C0 17.8389 5.1265 23 11.5 23C17.8735 23 23 17.8389 23 11.5C23 5.16114 17.8389 0 11.5 0ZM11.5 17.8735C10.6687 17.8735 10.0105 17.2154 10.0105 16.384H13.0241C12.9895 17.1807 12.3313 17.8735 11.5 17.8735ZM16.5572 14.8599C16.5572 15.4142 16.1069 15.4488 15.5527 15.4488H7.44729C6.89307 15.4488 6.44277 15.4142 6.44277 14.8599V14.756C6.44277 14.375 6.6506 14.0286 7.03162 13.8554L7.34337 11.119C7.34337 9.14458 8.76355 7.44729 10.634 7.03163V5.99247C10.634 5.50753 11.0151 5.12651 11.5 5.12651C11.9849 5.12651 12.366 5.50753 12.366 5.99247V7.03163C14.2364 7.41265 15.6566 9.10994 15.6566 11.119L15.9684 13.8554C16.2801 14.0286 16.5572 14.375 16.5572 14.756V14.8599Z",
    fill: "#6F82C4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6043_57",
    x1: 0,
    y1: 11.5,
    x2: 23,
    y2: 11.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.79233e-9,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsHeader);
export default __webpack_public_path__ + "static/media/notifications_header.09925ce1f69228457f8b1ea420b519c3.svg";
export { ForwardRef as ReactComponent };